import { Card, CardBody, CardHeader, CardTitle, Col, Input, Row } from "reactstrap";
import { Fragment, useEffect, useState } from "react";
import NotePreviewCard from "../Cards/NotePreview";
import { del, get, post } from "../../../../utils/helpers/api";
import NoteTextarea from "../Forms/NoteTextarea";
import ConfirmationModal from "../../../../components/Modals/Confirmation";
import { useTranslation } from "react-i18next";

function NotesSection({ objectData, objectType }) {
  const { t } = useTranslation();
  const [notesLoading, setNotesLoading] = useState(true);
  const [notesOrder, setNotesOrder] = useState('recent_last');
  const [notesData, setNotesData] = useState([]);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if(objectData?.id) {
      getNotes();
    }
  }, [objectData, notesOrder]);

  const getNotes = async () => {
    setNotesLoading(true);

    const data = await get(`/crm/notes/view/${objectType}/${objectData.id}?order=${notesOrder}`);
    if(data.success) {
      setNotesData(data.notes);
    }
    setNotesLoading(false);
  }

  const editNote = async (id, note_title, note_body) => {
    const data = await post(`/crm/notes/update/${objectType}/` + id, { note_title, note_body });
    if (data.success) getNotes();
  };

  const deleteNote = async () => {
    if(!noteToDelete) return;

    setDeleteLoading(true);

    const data = await del(`/crm/notes/delete/` + noteToDelete);
    if(data.success) {
      getNotes();
      setNoteToDelete(null);
    }
    setDeleteLoading(false);
  }

  return(
    <Fragment>
      <Card className="mt-3" id="notes-card">
        <CardHeader>
          <Row className="align-items-center">
            <Col md="9" xs="8">        
              <CardTitle tag="h5" className="mb-0 fw-bold py-1">{t('common.notes')}</CardTitle>
            </Col>
            <Col md="3" xs="4">
              <Input 
                type="select" 
                size="sm" 
                value={notesOrder} 
                onChange={e => setNotesOrder(e.target.value)}
              >
                <option value="recent_last">{t('common.recentLast')}</option>
                <option value="recent_first">{t('common.recentFirst')}</option>
              </Input>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {notesLoading ? (
            <p className="mb-0 text-center">{t('common.loading')}</p>
          ) : (
            notesData?.data?.length > 0 ? (
              notesData.data.map(note => (
                <NotePreviewCard
                  key={note.id}
                  noteData={note}
                  onDelete={() => setNoteToDelete(note.id)}
                  onEdit={editNote}
                />
              ))
            ) : (
              ""
            )
          )}

          <NoteTextarea 
            subjectId={objectData?.id}
            onSave={getNotes}
            subject={objectType}
          />
        </CardBody>
      </Card>

      <ConfirmationModal
        isOpen={noteToDelete !== null}
        title={t('notes.deleteNote')}
        message={t('notes.deleteNoteConfirm')}
        onConfirm={deleteNote}
        toggle={() => setNoteToDelete(null)}
      />
    </Fragment>
  );
}

export default NotesSection;